import React, { FC } from 'react';
import { getImage } from 'gatsby-plugin-image';

// ** Types
import { PartnerImages, PartnerType } from './partner.interfaces';

// ** Styles
import {
  PartnerStyled,
  StyledContent,
  StyledImage,
  StyledInner,
  StyledLogo,
  StyledLogoPNG,
} from './partner.styled';

// ** Components
import { Button, Typography } from 'components';

// ** Images
import big from 'assets/icons/partners/colorful/big-partner.svg';
import mantis from 'assets/icons/partners/colorful/mantis-partner.svg';
import stadia from 'assets/icons/partners/colorful/stadia.png';
import doubleday from 'assets/icons/partners/colorful/Doubleday.png';
import landspire from 'assets/icons/partners/colorful/Landspire.png';
import titletown from 'assets/icons/partners/colorful/Titletown.png';

const images: PartnerImages = [
  {
    type: 'svg',
    src: big,
    $logoHeight: 64,
    $mobileHeight: 54,
  },
  {
    type: 'png',
    src: landspire,
    $logoHeight: 140,
    $mobileHeight: 74,
  },
  {
    type: 'png',
    src: stadia,
    $logoHeight: 98,
    $mobileHeight: 64,
  },
  {
    type: 'svg',
    src: mantis,
    $logoHeight: 98,
    $mobileHeight: 84,
  },
  {
    type: 'png',
    src: doubleday,
    $logoHeight: 88,
    $mobileHeight: 44,
  },
  {
    type: 'png',
    src: titletown,
    $logoHeight: 88,
    $mobileHeight: 44,
  },
];

export const Partner: FC<PartnerType> = ({
  id,
  highlight,
  text,
  background,
  link,
}) => {
  const partnerBg = getImage(background);

  const onClick = () => {
    window.open(link, '_blank');
  };

  return (
    <PartnerStyled>
      <StyledInner>
        <StyledImage image={partnerBg} alt={highlight} />
      </StyledInner>
      {images[id].type === 'svg' ? (
        <StyledLogo {...images[id]} />
      ) : (
        <StyledLogoPNG {...images[id]} />
      )}

      <StyledContent>
        <Typography variant="span" isBold typographyType="bodyRegular">
          {highlight}
        </Typography>
        <Typography variant="span" typographyType="bodyRegular">
          {text}
        </Typography>
      </StyledContent>
      {!!link && (
        <Button
          onClick={onClick}
          color="black"
          size="medium"
          typographyProps={{
            isUppercase: true,
            typographyType: 'small',
            variant: 'span',
          }}
        >
          VIEW PARTNER
        </Button>
      )}
    </PartnerStyled>
  );
};
